import assignOffsetPagination from "@/schemas/assignOffsetPagination";
import { DiscountRewardSchema } from "@apps/rewards/schemas/RewardsRewardSchemas/RewardsDiscountRewardSchema";
import {
    assign,
    enums,
    nullable,
    number,
    object,
    omit,
    string,
    union,
} from "superstruct";

import { RewardsIconSchema } from "../../../schemas/RewardsIconSchema";
import { FreeProductRewardSchema } from "../../../schemas/RewardsRewardSchemas/RewardsFreeProductRewardSchema";
import { GiftCardRewardSchema } from "../../../schemas/RewardsRewardSchemas/RewardsGiftCardRewardSchema";
import { PointsRewardSchema } from "../../../schemas/RewardsRewardSchemas/RewardsPointsRewardSchema";
import { REWARDS_REFERRAL_STATUS } from "../constants";

export const RewardsReferralPointsRewardSchema = assign(
    PointsRewardSchema,
    object({
        spendAmountDivider: number(),
    })
);

export const RewardsReferralProgramRewardSchema = union([
    PointsRewardSchema,
    RewardsReferralPointsRewardSchema,
    omit(DiscountRewardSchema, ["discountCode"]),
    omit(GiftCardRewardSchema, ["code", "balance"]),
    FreeProductRewardSchema,
]);

const RewardsReferralSchema = object({
    icon: nullable(RewardsIconSchema),
    rewarding: nullable(RewardsReferralProgramRewardSchema),
});

export const RewardsReferralProgramSchema = object({
    prizeForSender: RewardsReferralSchema,
    prizeForReceiver: RewardsReferralSchema,
});

export const RewardsReferralsSchema = object({
    userId: number(),
    email: nullable(string()),
    firstName: nullable(string()),
    lastName: nullable(string()),
    status: enums(Object.values(REWARDS_REFERRAL_STATUS)),
    date: string(),
});

export const RewardsReferralsResponseSchema = assignOffsetPagination(
    RewardsReferralsSchema
);
